import { UserState } from './types'

const state = (): UserState => ({
  current: null,
  showNotificationMobile: false,
})

export default state
